module.exports = __webpack_public_path__ + "img/267-5.10dda220.png";